import sparePartsApi, {
  ApiResponse,
} from "../../../../api/spareParts.api";

import {
  Supplier,
  SupplierApiRow,
  SupplierFilters,
  SupplierListResponse,
  SupplierPayload,
  Pagination,
  RecordStatus,
} from "../types";
import vehicleService from "../../../../services/vehicleService";

const BASE_URL = "/suppliers";

const mapSupplier = (supplier: SupplierApiRow): Supplier => ({
  ...supplier,
  name: supplier.supplierName,
});

export const SupplierService = {
  async getCityOptions(): Promise<Array<{ id: string; name: string; state: string }>> {
    const response = await vehicleService
      .getOperationalCities()
      .catch(() => vehicleService.getCities({ isActive: true }));

    const cities = response?.data || [];

    return cities
      .filter((city: any) => city?.name)
      .map((city: any) => ({
        id: city.id || city.name,
        name: city.displayName || city.name,
        state: city.state || "",
      }))
      .sort((a: { name: string }, b: { name: string }) =>
        a.name.localeCompare(b.name)
      );
  },

  async getSuppliers(
    params?: SupplierFilters
  ): Promise<SupplierListResponse> {
    const response = await sparePartsApi.get<ApiResponse<SupplierApiRow[]>>(
      BASE_URL,
      { params }
    );

    return {
      data: (response.data.data || []).map(mapSupplier),
      pagination: response.data.meta as Pagination,
    };
  },

  async getSupplier(id: string): Promise<Supplier> {
    const response = await sparePartsApi.get<ApiResponse<SupplierApiRow>>(
      `${BASE_URL}/${id}`
    );

    return mapSupplier(response.data.data);
  },

  async createSupplier(
    data: SupplierPayload
  ): Promise<Supplier> {
    const response = await sparePartsApi.post<ApiResponse<SupplierApiRow>>(
      BASE_URL,
      data
    );

    return mapSupplier(response.data.data);
  },

  async updateSupplier(
    id: string,
    data: SupplierPayload
  ): Promise<Supplier> {
    const response = await sparePartsApi.put<ApiResponse<SupplierApiRow>>(
      `${BASE_URL}/${id}`,
      data
    );

    return mapSupplier(response.data.data);
  },

  async updateStatus(
    id: string,
    status: RecordStatus
  ): Promise<Supplier> {
    const response = await sparePartsApi.patch<ApiResponse<SupplierApiRow>>(
      `${BASE_URL}/${id}/status`,
      { status }
    );

    return mapSupplier(response.data.data);
  },

  async deleteSupplier(id: string): Promise<void> {
    await sparePartsApi.delete(`${BASE_URL}/${id}`);
  },
};
